import {lemon} from "./lemon";
import {concatPath, isNotEmpty} from "./common";

let imagePreviewer = null;
export function previewImage({src, image_path}){
    if(imagePreviewer == null){
        initImagePreview();
    }
    let previewerBox = lemon("#previewerContainer").find(".previewer-box");
    previewerBox.empty();
    let figure = document.createElement("figure");
    figure.innerHTML = `<img src="">`;
    let img = lemon(figure).find("img");
    if(isNotEmpty(image_path)){
        img.attr("src", concatPath(_IMG_PATH, image_path));
    }else if(isNotEmpty(src)){
        img.attr("src", src);
    }
    previewerBox.append(figure);
    imagePreviewer.classList.remove('is-hide');
}

export function initImagePreview(){
    let insertHtml=`
    <!-- loading -->
    <div id="previewerContainer" class="is-hide">
        <div class="previewer-box">
            <figure></figure>
        </div>
    </div>
    <!-- loading -->
    `
    let insertCSS=`
    <style>
        body{
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
        #previewerContainer{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 999;
            width: 100%;
            height:100%;
            background: rgba(0,0,0,0.6);
        }
        #previewerContainer .previewer-box {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 100%;
            }
        }
        #previewerContainer.is-hide{
            display:none;
        }
    </style>
    `
    document.getElementsByTagName('head')[0]
        .insertAdjacentHTML('beforeend', insertCSS);
    document.getElementsByTagName('body')[0]
        .insertAdjacentHTML('afterbegin', insertHtml);

    imagePreviewer = document.getElementById('previewerContainer');
    imagePreviewer.addEventListener("click",function(){
        document.getElementById('previewerContainer').classList.add('is-hide');
    });
}